// Copyright (c) 2016 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['pipCompletionStatus', 'value'],
        sortDirection: 'DESC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/pip/pip-details/state/search-filters.js